export default __webpack_public_path__ + "static/media/overwhelm4.06aa474a.png";